document.addEventListener('DOMContentLoaded', function() {
  // Custom Select Logic
  const customSelects = document.querySelectorAll('.custom-select-source');
  
  customSelects.forEach(select => {
      const wrapper = select.parentElement;
      
      // Create Custom UI elements
      const customSelect = document.createElement('div');
      customSelect.classList.add('custom-select');
      
      const trigger = document.createElement('div');
      trigger.classList.add('custom-select__trigger');
      trigger.classList.add('exp-field__input');
      
      // Get initial text (placeholder or selected)
      const selectedOption = select.options[select.selectedIndex];
      let initialText = selectedOption ? selectedOption.text : '';
      let isPlaceholder = selectedOption ? (selectedOption.disabled || selectedOption.value === "") : true;

      if (!initialText || initialText.trim() === '') {
          initialText = '&nbsp;';
      }
      
      trigger.innerHTML = `<span>${initialText}</span>`;
      trigger.setAttribute('tabindex', '0'); // Make focusable
      
      if(isPlaceholder) {
          trigger.classList.add('placeholder-style');
      } else {
          wrapper.classList.add('is-filled');
      }
      
      // Accessibility & Floating Label Focus State
      trigger.addEventListener('focus', () => wrapper.classList.add('is-focused'));
      trigger.addEventListener('blur', () => {
          wrapper.classList.remove('is-focused');
          // Start Time / End Time don't clear, but if they did, check value here
      });
      
      // Add Chevron Icon
      const iconSvg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret icon-chevron-down" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>`;
      trigger.insertAdjacentHTML('beforeend', iconSvg);
      
      const optionsContainer = document.createElement('div');
      optionsContainer.classList.add('custom-options');
      
      // Populate options
      Array.from(select.options).forEach(option => {
          if (option.disabled && option.value === "") return; 
          
          const customOption = document.createElement('span');
          customOption.classList.add('custom-option');
          customOption.dataset.value = option.value;
          customOption.textContent = option.text;
          
          if (option.selected) {
              customOption.classList.add('selected');
          }
          
          customOption.addEventListener('click', function(e) {
              e.stopPropagation();
              
              // Update Trigger
              trigger.classList.remove('placeholder-style'); 
              void trigger.offsetWidth; // Force reflow/repaint
              trigger.querySelector('span').textContent = this.textContent;
              
              // Set Filled State for Floating Label
              wrapper.classList.add('is-filled');
              
              // Update Native Select
              select.value = this.dataset.value;
              
              // Trigger Change Event for other listeners (validation)
              select.dispatchEvent(new Event('change'));
              
              // Update UI Classes
              customSelect.classList.remove('open');
              optionsContainer.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
              this.classList.add('selected');
          });
          
          optionsContainer.appendChild(customOption);
      });
      
      // Trigger Click
      trigger.addEventListener('click', function(e) {
         e.stopPropagation();
         // Close others
         document.querySelectorAll('.custom-select').forEach(cs => {
             if(cs !== customSelect) cs.classList.remove('open');
         });
         customSelect.classList.toggle('open');
      });
      
      customSelect.appendChild(trigger);
      customSelect.appendChild(optionsContainer);
      wrapper.appendChild(customSelect);
  });
  
  // Close on click outside
  document.addEventListener('click', function(e) {
      if (!e.target.closest('.custom-select')) {
          document.querySelectorAll('.custom-select').forEach(cs => cs.classList.remove('open'));
      }
  });



  // Date Picker Logic
  const datePicker = document.getElementById('ContactForm-date-picker');
  const dateDisplay = document.getElementById('ContactForm-date-display');
  const dateSubmission = document.getElementById('ContactForm-date-submission');

  if (datePicker) {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    function updateDateDisplay(dateStr) {
        if (!dateStr) {
             if(dateDisplay) dateDisplay.value = '';
             if(dateSubmission) dateSubmission.value = '';
             return;
        }
        
        const parts = dateStr.split('-'); 
        // parts[0] = year, parts[1] = month, parts[2] = day
        
        if(parts.length === 3) {
             const year = parts[0];
             const monthIndex = parseInt(parts[1]) - 1; 
             const day = parts[2]; 

             // Format: "DD / Month / YYYY"
             const formattedDate = `${day} / ${monthNames[monthIndex]} / ${year}`;

             // Populate hidden submission input
             if(dateSubmission) dateSubmission.value = formattedDate;
             
             // Populate Display Input (User Friendly)
             if(dateDisplay) {
                 dateDisplay.value = formattedDate;
             }
        }
    }

    datePicker.addEventListener('change', function() {
        updateDateDisplay(this.value);
    });
    
    // Initial check (browser might preserve value on reload)
    if(datePicker.value) {
        updateDateDisplay(datePicker.value);
    }
    
    // Force open on click for invisible overlay
    datePicker.addEventListener('click', function(e) {
        try {
            if(typeof this.showPicker === 'function') {
                this.showPicker();
            } else {
                this.focus();
            }
        } catch(err) {
            console.log('Error opening picker:', err);
        }
    });
  }

  // Strict Phone Number Validation (Digits and + only)
  const phoneInput = document.getElementById('ContactForm-phone');
  if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
          this.value = this.value.replace(/[^0-9+]/g, '');
      });
  }
});
